import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4 4V15.528C5.10002 14.544 6.52412 14 8 14C11 14 13 16 16 16C17.2982 16 18.5614 15.5789 19.6 14.8C19.7242 14.7069 19.825 14.5861 19.8944 14.4472C19.9639 14.3084 20 14.1552 20 14V4C20 3.81429 19.9483 3.63224 19.8507 3.47427C19.753 3.31629 19.6133 3.18863 19.4472 3.10557C19.2811 3.02252 19.0952 2.98736 18.9102 3.00404C18.7252 3.02072 18.5486 3.08857 18.4 3.2C17.6887 3.73333 16.6663 4 15.333 4C13 4 11 2 8 2C6.70178 2 5.43858 2.42107 4.4 3.2C4.2758 3.29315 4.175 3.41393 4.10557 3.55279C4.03614 3.69164 4 3.84475 4 4Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4 22V4C4 3.84475 4.03614 3.69164 4.10557 3.55279C4.175 3.41393 4.2758 3.29315 4.4 3.2C5.43858 2.42107 6.70178 2 8 2C11 2 13 4 15.333 4C16.6663 4 17.6887 3.73333 18.4 3.2C18.5486 3.08857 18.7252 3.02072 18.9102 3.00404C19.0952 2.98736 19.2811 3.02252 19.4472 3.10557C19.6133 3.18863 19.753 3.31629 19.8507 3.47427C19.9483 3.63224 20 3.81429 20 4V14C20 14.1552 19.9639 14.3084 19.8944 14.4472C19.825 14.5861 19.7242 14.7069 19.6 14.8C18.5614 15.5789 17.2982 16 16 16C13 16 11 14 8 14C6.52412 14 5.10002 14.544 4 15.528",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgFilledFlag;
